﻿/*
 * Globalize Culture nl-NL
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("nl-NL", "default", {
    name: "nl-NL",
    englishName: "Dutch (Netherlands)",
    nativeName: "Nederlands (Nederland)",
    language: "nl",
    numberFormat: {
      ",": ".",
      ".": ",",
      percent: {
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["$ -n", "$ n"],
        ",": ".",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        "/": "-",
        firstDay: 1,
        days: {
          names: [
            "zondag",
            "maandag",
            "dinsdag",
            "woensdag",
            "donderdag",
            "vrijdag",
            "zaterdag"
          ],
          namesAbbr: ["zo", "ma", "di", "wo", "do", "vr", "za"],
          namesShort: ["zo", "ma", "di", "wo", "do", "vr", "za"]
        },
        months: {
          names: [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december",
            ""
          ],
          namesAbbr: [
            "jan",
            "feb",
            "mrt",
            "apr",
            "mei",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "d-M-yyyy",
          D: "dddd d MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "dddd d MMMM yyyy H:mm",
          F: "dddd d MMMM yyyy H:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Extra help",
      AddNewTab: "Nieuw tabblad toevoegen",
      Alerts: "Alarmeringen",
      ApplyFilter: "Filter toepassen",
      Approve: "Goedkeuren",
      Attachments: "Bijlagen",
      Back: "Terug",
      Basic: "Basis",
      Between: "Tussen",
      Book: "Boeken",
      Cancel: "Annuleren",
      Checked: "Ingeschakeld",
      ClearFilter: "Filter wissen",
      Close: "Sluiten",
      CloseCancelChanges: "Afsluiten en wijzigingen annuleren",
      CloseSaveChanges: "Afsluiten en wijzigingen opslaan",
      CloseTab: "Tabblad sluiten",
      ColumnPersonalization: "Personalisatie kolommen",
      Comments: "Opmerkingen",
      Confirmation: "Bevestiging",
      Contains: "Bevat",
      CreateTab: "Een  nieuw tabblad aanmaken",
      Cut: "Knippen",
      Delete: "Verwijderen",
      DiscardUndo: "Ongedaan maken",
      DisplayDropDownList: "Keuzelijst weergeven",
      Displaying: "Weergave: ",
      DocWord: "Document",
      DoesNotContain: "Bevat niet",
      DoesNotEndWith: "Eindigt niet op",
      DoesNotEqual: "Is niet gelijk aan",
      DoesNotStartWith: "Begint niet met",
      Download: "Downloaden",
      Duplicate: "Kopiëren",
      Edit: "Bewerken",
      EitherSelectedorNotSelected: "Ingeschakeld of Uitgeschakeld",
      Email: "E-mail",
      EndsWith: "Eindigt op",
      EqualsStr: "Is gelijk aan",
      ExpandCollapse: "Uit-/invouwen",
      ExportFailed: "Exporteren is niet gelukt",
      ExportToExcel: "Naar Excel exporteren",
      FileInUse: "Opgegeven bestand is in gebruik",
      FileInUseDetail:
        "Sluit het bestand in de applicatie waar het in gebruik is of geef een andere bestandsnaam op.",
      Filter: "Filter",
      FilterMenu: "Filtermenu",
      FilterOptions: "Filteropties",
      FilterWithinResults: "Binnen resultaten filteren",
      First: "Eerste",
      FirstView: "Eerste weergave",
      Folder: "Map",
      ForgotPassword: "Bent u uw wachtwoord vergeten?",
      Forward: "Vooruit",
      GetMoreRows: "Meer rijen ophalen",
      GreaterThan: "Groter dan",
      GreaterThanOrEquals: "Groter dan of gelijk aan",
      GridSettings: "Rasterinstellingen",
      GroupSelection: "Groepsselectie",
      Help: "Help",
      HideColumn: "Kolom verbergen",
      IsEmpty: "Is leeg",
      IsNotEmpty: "Is niet leeg",
      Last: "Laatste",
      LastView: "Laatste weergave",
      LaunchActivate: "Starten/activeren",
      LessThan: "Kleiner dan",
      LessThanOrEquals: "Kleiner dan of gelijk aan",
      Links: "Koppelingen",
      ListTabs: "Alle tabbladen weergeven",
      LoadingItem: "Artikel laden ",
      Maintenance: "Onderhoud",
      Menu: "Menu",
      New: "Nieuw",
      Next: "Volgende",
      NextView: "Volgende weergave",
      No: "Nee",
      NotChecked: "Niet ingeschakeld",
      Notes: "Notities",
      NotSelected: "Niet geselecteerd",
      Of: " van ",
      Ok: "OK",
      Open: "Open",
      Password: "Wachtwoord",
      Paste: "Plakken",
      Phone: "Telefoon",
      PleaseWait: "Ogenblik svp",
      Previous: "Vorige",
      PreviousView: "Vorige weergave",
      Print: "Afdrukken",
      Queries: "Query\u0027s",
      Redo: "Opnieuw uitvoeren",
      Refresh: "Vernieuwen",
      Reject: "Afkeuren",
      RememberMe: "Herinner mij op deze computer",
      Reports: "Rapporten",
      Reset: "Herstellen",
      Review: "Bekijken",
      RunFilter: "Filter uitvoeren",
      RunJob: "Job uitvoeren",
      Save: "Opslaan",
      SaveBeforeClosing: "Opslaan vóór afsluiten",
      SavedFilters: "Opgeslagen filters",
      SaveSubmit: "Opslaan",
      ScreenDesign: "Schermontwerp",
      Search: "Zoeken",
      SelectContents: "Inhoud selecteren",
      SelectDate: "Een datum selecteren",
      SelectDeselect: "Alles selecteren /deselecteren",
      Selected: "Geselecteerd: ",
      ServerName: "Servernaam",
      Settings: "Instellingen",
      ShowFilterRow: "Filterrij tonen",
      SignIn: "Aanmelden",
      SortAscending: "Oplopend sorteren",
      SortDescending: "Aflopend sorteren",
      Spreadsheet: "Rekenblad",
      StartsWith: "Begint met",
      StatusIndicator: "Statusindicator",
      Tasks: "Taken",
      Today: "Vandaag",
      Translate: "Vertalen",
      UserID: "Gebruiker-ID",
      Utilities: "Hulpprogramma\u0027s",
      Yes: "Ja",
      Page: "Pagina",
      Rows: "Rijen",
      ShowingAll: "Alles weergeven",
      SessionNavigation: "Navigeren in sessie",
      ListAllMenuItems: "Alle menuopdrachten weergeven",
      NoRecordsFound: "Geen records aanwezig",
      SearchTree: "In structuur zoeken",
      Clear: "Wissen",
      DrillDown: "Drill-down",
      Required: "Dit veld is verplicht",
      Available: "Beschikbaar:",
      Add: "Toevoegen",
      MoveDown: "Omlaag",
      MoveUp: "Omhoog",
      Remove: "Verwijderen",
      LastYear: "Vorig jaar",
      NextMonth: "Volgende maand",
      NextWeek: "Volgende week",
      NextYear: "Volgend jaar",
      OneMonthAgo: "Eén maand geleden",
      OneWeekAgo: "Eén week geleden",
      SixMonthsAgo: "Half jaar geleden",
      Time: "Tijd",
      CannotBeSelected: "Deze rij kan niet worden geselecteerd.",
      ResetToDefault: "Naar standaardinstelling terugzetten",
      CloseOtherTabs: "Overige tabbladen sluliten",
      EmailValidation: "Voer een geldig e-mailadres in",
      UrlValidation: "Voer een geldige URL in",
      EndofResults: "Einde resultaten",
      More: "Meer...",
      RecordsPerPage: "Records per pagina",
      Maximize: "Maximaliseren",
      Minimize: "Minimaliseren",
      CloseAllTabs: "Alle tabbladen sluiten",
      QuickDates: "Snelle datums",
      Finish: "Beëindigen",
      SetTextColor: "Tekstkleur instellen",
      AttachmentRules: "Regels bijlagen",
      AutoRefresh: "Automatisch vernieuwen",
      BarChart: "staafdiagram",
      CopyMail: "Kopiëren en per e-mail verzenden",
      CopyUrl: "URL kopiëren",
      DistributeHorizontally: "Horizontaal verdelen",
      ExpandAll: "Alles uitvouwen",
      Generate: "Genereren",
      GenerateScript: "Script genereren",
      NoAttachments: "Geen bijlagen",
      PieChart: "Cirkeldiagram",
      QuickAccess: "Snelle toegang",
      RestoreUser: "Gebruiker terugzetten",
      SaveConsolidate: "Met lokale consolidatie opslaan",
      "Screen Design": "Schermontwerp",
      SelectAll: "Alles selecteren",
      SpellCheck: "Spellingscontrole",
      SubmitForApproval: "Ter goedkeuring voorleggen",
      TopDownSpread: "Top-down spreiding",
      Timezone: "Tijdzone",
      Loading: "Laden...",
      NewNode: "Nieuw knooppunt"
    }
  });
})(this);
